<template>
    <div>
        <el-form ref="form"
                 :model="form"
                 label-width="100px"
                 @submit.prevent.native="onSubmit">
            <el-row :gutter="30">
                <el-col :span="19">
                    <div class="box">
                        <div class="box__header">
                            <span class="box__header--text">{{ getRouteName($route) }}</span>
                            <form-language-switcher></form-language-switcher>
                        </div>
                        <el-form-item label="Tytuł"
                                      :error="errors[addLanguageSuffix('title')]"
                                      required>
                            <el-input v-model="form[addLanguageSuffix('title')]"/>
                        </el-form-item>
                        <el-form-item label="Ukryj zdjęcie oraz treść w szczegółach">
                            <el-switch v-model="form.hide_default_widget"/>
                        </el-form-item>
                        <el-form-item label="Tekst na kafelku"
                                      :error="errors[addLanguageSuffix('tile_text')]">
                            <el-input v-model="form[addLanguageSuffix('tile_text')]"/>
                        </el-form-item>
                        <el-form-item label="Treść"
                                      :error="errors[addLanguageSuffix('description')]">
                            <wyswig-input v-model="form[addLanguageSuffix('description')]"/>
                        </el-form-item>
                        <el-form-item label="Tagi"
                                      :error="errors['tags']">
                            <el-select v-model="form['tags']"
                                       class="fluid"
                                       filterable
                                       multiple
                                       default-first-option
                                       placeholder="Tagi"
                                       allow-create>
                                <el-option
                                        v-for="item in tags"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Popup">
                            <el-select v-model="form.popup"
                                       filterable
                                       clearable
                                       placeholder="Wybierz popup">
                                <el-option
                                        v-for="item in popups"
                                        :key="item.id"
                                        :label="item.working_name"
                                        :value="item.id"/>
                            </el-select>
                        </el-form-item>
                        <div>
                            <div class="box__header box__header--photos">
                                <span class="box__header--text">Zdjęcia:</span>
                            </div>
                            <photo-cropper :photo.sync="form.photo"
                                           :errors="errors"
                                           :croppers.sync="croppers"/>
                        </div>
                        <div>
                            <div class="box__header">
                                <span class="box__header--text">Widgety - widoczne w szczegółach:</span>
                            </div>
                            <widgets-input :widgets.sync="form.widgets"
                                           :lessDetails="true"
                                           :errors="errors.widgets || []"/>
                        </div>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="box">
                        <div class="box__header">
                            {{ $t('manage') }}
                        </div>
                        <el-form-item class="form__buttons" label-width="0">
                            <router-link :to="redirectRoute">
                                <el-button class="fluid form__button">{{ $t('cancel') }}</el-button>
                            </router-link>
                            <el-button @click="onSubmit"
                                       type="primary"
                                       class="fluid form__button"
                                       :loading="loading">
                                {{ $t('submit') }}
                            </el-button>
                            <div class="el-form-item timestamp">
                                <label>
                                    Data publikacji
                                    <div class="el-form-item__error" v-if="errors.timestamp">
                                        {{ errors.timestamp }}
                                    </div>
                                    <el-date-picker class="timestamp__input"
                                                    v-model="form.timestamp"
                                                    :clearable="false"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    type="datetime"
                                                    placeholder="Select date and time">
                                    </el-date-picker>
                                </label>
                            </div>
                            <label>
                                Ukryj
                                <el-switch v-model="form.hide"/>
                            </label>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import WidgetsInput from '@/components/widgets/WidgetsInput'
    import PhotoCropper from '@/components/PhotoCropper'
    import {Popup, News} from '@/api'


    export default {
        data () {
            return {
                loading: false,
                form: {
                    widgets: []
                },
                errors: {},
                loadingPopups: false,
                popups: [],
                service: News,
                tags: [],
                redirectRoute: {name: 'News List'}
            }
        },
        mounted () {
            this.fetchData()
        },
        computed: {
            croppers: {
                set (updatedCroppers) {
                    updatedCroppers.forEach(cropper => {
                        this.$set(this.form, cropper.photoFieldName, cropper.img)
                        this.$set(this.form, cropper.paramsFieldName, cropper.params)
                    })
                },
                get () {
                    const croppers = [
                        {
                            id: 'square',
                            aspect: 1,
                            photoFieldName: 'square_photo',
                            paramsFieldName: 'square_crop_params',
                            label: 'Kadr kwadratowy'
                        },
                        {
                            id: 'horizontal',
                            aspect: 2,
                            photoFieldName: 'horizontal_photo',
                            paramsFieldName: 'horizontal_crop_params',
                            label: 'Kadr poziomy'
                        },
                        {
                            id: 'vertical',
                            aspect: 260 / 378,
                            photoFieldName: 'vertical_photo',
                            paramsFieldName: 'vertical_crop_params',
                            label: 'Kadr pionowy'
                        },
                    ]
                    const mergeFieldNameWithValues = cropper => {
                        return {
                            ...cropper,
                            img: this.form[cropper.photoFieldName],
                            params: this.form[cropper.paramsFieldName]
                        }
                    }
                    return croppers.map(mergeFieldNameWithValues)
                }
            }
        },
        components: {
            WidgetsInput,
            PhotoCropper
        },
        methods: {
            fetchData () {
                if (this.$route.params.id) {
                    this.service.get({id: this.$route.params.id}).then(response => {
                        this.form = response.data
                        this.form.tags = this.form.tags.map(tag => tag.name)
                    })
                }
                this.fetchPopups()
                this.fetchTags()
            },
            fetchTags () {
                this.service.tags().then(response => {
                    const listToObj = item => {
                        return {name: item.name, id: item.id}
                    }

                    this.tags = response.data.map(listToObj)
                })
            },
            fetchPopups () {
                Popup.all().then(response => {
                    this.popups = response.data
                })
            },
            onSubmit () {
                this.loading = true;
                const id = this.$route.params.id
                const payload = {...this.form}
                const prepareTags = tag => typeof tag === 'string' ? {name: tag} : tag
                payload.tags = payload.tags.map(prepareTags)
                const service = id ? this.service.update({id: id}, payload) : this.service.save(payload)
                service
                    .then(this.successHandler)
                    .catch(this.errorHandler)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .box__header {
        &--photos {
            margin-top: 40px;
        }
    }

    .timestamp {
        &__input {
            max-width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// NewsForm.vue?75d91d4f